webpackJsonp([22],{

/***/ 1536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackupCloud_vue__ = __webpack_require__(1902);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_322b4b8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackupCloud_vue__ = __webpack_require__(2333);
function injectStyle (ssrContext) {
  __webpack_require__(2319)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackupCloud_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_322b4b8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackupCloud_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__(1545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__(1553);
function injectStyle (ssrContext) {
  __webpack_require__(1551)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64c87b52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64c87b52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Otwarte modale w kolejności otwierania. Esc zamyka tylko ostatni, żeby przy
// zagnieżdżonych modalach (np. wykres otwierany z modala szczegółów alarmów)
// nie zamykały się wszystkie naraz.
var openModals = [];

// Esc w otwartej liście vue-select / vue-multiselect zamyka samą listę; przy
// otwartym kalendarzu vue2-datepicker też nie ruszamy modala, żeby jednym
// klawiszem nie stracić wypełnionego formularza.
var OPEN_DROPDOWN = '.vs--open, .multiselect--active';
var OPEN_DATEPICKER = '.mx-datepicker-popup';

// Faza capture: sprawdzamy listy, zanim ich własna obsługa Esc je zamknie.
function onDocumentKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var topModal = openModals[openModals.length - 1];
    if (topModal == null) return;

    var target = event.target;
    if (target instanceof Element && target.closest(OPEN_DROPDOWN) != null) return;
    if (document.querySelector(OPEN_DATEPICKER) != null) return;

    topModal.$emit('close');
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: {
            immediate: true,
            handler: function handler(isOpen) {
                isOpen ? this.registerOpen() : this.unregisterOpen();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.unregisterOpen();
    },

    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    },
    methods: {
        registerOpen: function registerOpen() {
            if (openModals.includes(this)) return;
            openModals.push(this);
            if (openModals.length === 1) {
                document.addEventListener('keydown', onDocumentKeydown, true);
            }
        },
        unregisterOpen: function unregisterOpen() {
            var index = openModals.indexOf(this);
            if (index === -1) return;
            openModals.splice(index, 1);
            if (openModals.length === 0) {
                document.removeEventListener('keydown', onDocumentKeydown, true);
            }
        }
    }
});

/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  emits: ['onClick'],
  props: {
    title: {
      type: String,
      default: '',
      required: false
    },
    buttonClass: {
      type: String,
      default: '',
      required: false
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    onClick: function onClick() {
      this.$emit('onClick');
    }
  },
  computed: {
    buttonDef: function buttonDef() {
      return this.buttonClass === '' ? 'my-button' : '' + this.buttonClass;
    }
  }
});

/***/ }),

/***/ 1546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1544);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1550);
function injectStyle (ssrContext) {
  __webpack_require__(1548)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-330662f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1549);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6de141c4", content, true, {});

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-330662f6]{position:fixed;z-index:110;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-330662f6]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex}.modal-content[data-v-330662f6]{margin:auto;background-color:#fefefe;border:unset;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-330662f6]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-330662f6]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-330662f6]:focus,.close[data-v-330662f6]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-330662f6]{max-width:30%}#mdiv[data-v-330662f6]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-330662f6]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-330662f6]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Modal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAGhB,YAAa,AACb,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AAKD,gCACI,YAAa,AACb,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AAKD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ","file":"Modal.vue","sourcesContent":["\n.modal[data-v-330662f6] {\n    position: fixed;\n    /* Nad paskiem górnym (.app-header, z-index 20) i mobilnym menu (99/100),\n       ale pod popupami doklejanymi do body (Syncfusion 1000, datepicker 2001). */\n    z-index: 110;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-330662f6] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n/* margin: auto zamiast align-items/justify-content: center — modal wyższy od\n   ekranu zaczyna się od góry i da się go przewinąć do nagłówka z krzyżykiem\n   (przy centrowaniu flexem jego górna część wystawała poza ekran). */\n.modal-content[data-v-330662f6] {\n    margin: auto;\n    background-color: #fefefe;\n    border: unset;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-330662f6] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-330662f6] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-330662f6]:hover,\n.close[data-v-330662f6]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-330662f6] {\n    max-width: 30%;\n}\n.modal-slot[data-v-330662f6] {\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-330662f6] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container"},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : '')+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1552);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("9f84328e", content, true, {});

/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".my-button[data-v-64c87b52]{background:transparent;outline:none;border:none}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Button.vue"],"names":[],"mappings":"AACA,4BACI,uBAAwB,AACxB,aAAc,AACd,WAAa,CAChB","file":"Button.vue","sourcesContent":["\n.my-button[data-v-64c87b52] {\n    background: transparent;\n    outline: none;\n    border: none;\n}\n.my-button[data-v-64c87b52]:hover {\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.buttonDef,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t(_vm.title))+"\n  "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Select',
    props: {
        selected: {},
        options: {},
        title: {},
        description: {},
        label: {},
        disabled: {},
        selectClass: {},
        errorMode: {
            type: String,
            default: ''
        },
        clearable: {
            default: true
        }
    },
    watch: {
        selected: function selected(newVal, oldVal) {
            this.selectedOption = newVal;
        },
        options: function options(newVal, oldVal) {
            this.optionsList = newVal;
        }
    },
    methods: {
        onChange: function onChange() {}
    },
    components: {},
    computed: {
        classDef: function classDef() {
            return this.errorMode === '' ? 'select ' + this.selectClass : 'error ' + this.selectClass;
        }
    },
    mounted: function mounted() {},
    data: function data() {
        return {
            selectedOption: this.selected,
            optionsList: this.options
        };
    },
    created: function created() {}
});

/***/ }),

/***/ 1616:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select_vue__ = __webpack_require__(1601);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b0dfaff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select_vue__ = __webpack_require__(1662);
function injectStyle (ssrContext) {
  __webpack_require__(1658)
  __webpack_require__(1660)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b0dfaff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b0dfaff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1658:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1659);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("1f375ab7", content, true, {});

/***/ }),

/***/ 1659:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".v-select .dropdown-toggle .clear{margin-top:4px;color:#0095b2!important}.v-select .open-indicator:before{border-color:#0095b2!important}.v-select.disabled .dropdown-toggle input{background-color:transparent!important;cursor:default!important}.select,.select-error{border:1px solid #a3d4e0}.v-select.disabled .dropdown-toggle,.v-select.disabled .dropdown-toggle .clear,.v-select.disabled .dropdown-toggle input,.v-select.disabled .open-indicator,.v-select.disabled .selected-tag .close .form-control[disabled]{cursor:default!important}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Select.vue"],"names":[],"mappings":"AAiEA,kCAEI,eAAgB,AAChB,uBAA0B,CAC7B,AACD,iCACI,8BAAiC,CACpC,AACD,0CACI,uCAAyC,AACzC,wBAA2B,CAC9B,AASD,sBACI,wBAA0B,CAC7B,AACD,4NAMI,wBAA2B,CAC9B","file":"Select.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*.v-select .dropdown-toggle .clear { visibility: hidden; }*/\n.v-select .dropdown-toggle .clear\n{\n    margin-top: 4px;\n    color: #0095B2 !important;\n}\n.v-select .open-indicator:before {\n    border-color: #0095B2 !important;\n}\n.v-select.disabled .dropdown-toggle input {\n    background-color: transparent !important;\n    cursor: default !important;\n}\n/*\n.v-select .dropdown-toggle {\n  border: 1px solid #A3D4E0 !important;\n}\n*/\n.select-error {\n    border: 1px solid #A3D4E0;\n}\n.select {\n    border: 1px solid #A3D4E0;\n}\n.v-select.disabled .dropdown-toggle,\n.v-select.disabled .dropdown-toggle .clear,\n.v-select.disabled .dropdown-toggle input,\n.v-select.disabled .open-indicator,\n.v-select.disabled .selected-tag .close\n.form-control[disabled] {\n    cursor: default !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1660:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1661);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("fd1da36a", content, true, {});

/***/ }),

/***/ 1661:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".v-select[data-v-7b0dfaff]{width:100%;color:#000;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:5px;height:35px;font-size:14px;font-family:SourceSansProRegular,sans-serif!important}.title[data-v-7b0dfaff]{width:160px;font-family:SourceSansProSemiBold,sans-serif!important;font-weight:700;font-size:14px;margin:0}.desc[data-v-7b0dfaff]{font-style:italic;font-size:13px;color:#606b6c}.error[data-v-7b0dfaff]{font-weight:700}.v-select.disabled[data-v-7b0dfaff]{border:none!important}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Select.vue"],"names":[],"mappings":"AACA,2BACI,WAAY,AACZ,WAAa,AACb,8BAA+B,AACvB,sBAAuB,AAC/B,kBAAmB,AACnB,YAAa,AACb,eAAgB,AAChB,qDAA2D,CAC9D,AACD,wBACI,YAAa,AACb,uDAA4D,AAC5D,gBAAkB,AAClB,eAAgB,AAChB,QAAU,CACb,AACD,uBACI,kBAAmB,AACnB,eAAgB,AAChB,aAAyB,CAC5B,AACD,wBACI,eAAkB,CACrB,AACD,oCACI,qBAAwB,CAC3B","file":"Select.vue","sourcesContent":["\n.v-select[data-v-7b0dfaff] {\n    width: 100%;\n    color: black;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    border-radius: 5px;\n    height: 35px;\n    font-size: 14px;\n    font-family: 'SourceSansProRegular', sans-serif !important;\n}\n.title[data-v-7b0dfaff] {\n    width: 160px;\n    font-family: 'SourceSansProSemiBold', sans-serif !important;\n    font-weight: bold;\n    font-size: 14px;\n    margin: 0;\n}\n.desc[data-v-7b0dfaff] {\n    font-style: italic;\n    font-size: 13px;\n    color: rgb(96, 107, 108);\n}\n.error[data-v-7b0dfaff] {\n    font-weight: bold;\n}\n.v-select.disabled[data-v-7b0dfaff] {\n    border: none !important;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._v(" "),_c('v-select',{ref:"vselect",class:_vm.classDef,attrs:{"options":_vm.optionsList,"label":_vm.label,"onChange":function (value) { return this$1.$emit('onChange', value); },"disabled":_vm.disabled,"clearable":_vm.clearable},model:{value:(_vm.selectedOption),callback:function ($$v) {_vm.selectedOption=$$v},expression:"selectedOption"}}),_vm._v(" "),(_vm.errorMode === '')?_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._v(" "),(_vm.errorMode !== '')?_c('p',{staticClass:"error",staticStyle:{"font-size":"13px","font-weight":"bold","border":"none","color":"rgb(218, 97, 97)"}},[_vm._v(_vm._s(_vm.errorMode))]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1902:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Modal_vue__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Cloud_AddCloudModal_vue__ = __webpack_require__(2321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Cloud_AddCloudSystemModal_vue__ = __webpack_require__(2325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Cloud_EditCloudSystem_vue__ = __webpack_require__(2329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_api__ = __webpack_require__(952);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Modal: __WEBPACK_IMPORTED_MODULE_3__components_Modal_vue__["a" /* default */],
        AddCloudModal: __WEBPACK_IMPORTED_MODULE_4__components_Cloud_AddCloudModal_vue__["a" /* default */],
        AddCloudSystemModal: __WEBPACK_IMPORTED_MODULE_5__components_Cloud_AddCloudSystemModal_vue__["a" /* default */],
        EditCloudSystem: __WEBPACK_IMPORTED_MODULE_6__components_Cloud_EditCloudSystem_vue__["a" /* default */]
    },
    data: function data() {
        return {
            servers: [],
            systems: [],
            selectedServer: null,
            selectedSystem: null,
            activeModal: "",
            toolbar: [{
                text: this.$t("ClearFilter"),
                id: "clear-filters",
                prefixIcon: "e-cancel",
                align: "Right"
            }, {
                text: this.$t("AddConfiguration"),
                tooltipText: "Add Configuration",
                prefixIcon: "e-add",
                id: "add-config",
                align: "Right"
            }, {
                text: this.$t("EditConfiguration"),
                tooltipText: "Edit Configuration",
                prefixIcon: "e-edit",
                id: "edit-config",
                align: "Right"
            }, {
                text: this.$t("Delete"),
                tooltipText: "Delete Configuration",
                prefixIcon: "e-delete",
                id: "delete-config",
                align: "Right"
            }, "Search"],
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Single" },
            filterOptions: {
                type: "Menu"
            },
            toolbarSystems: [{
                text: this.$t("Add"),
                tooltipText: "Add Systems",
                prefixIcon: "e-add",
                id: "add-systems",
                align: "Right"
            }, {
                text: this.$t("Edit"),
                tooltipText: "Edit System",
                prefixIcon: "e-edit",
                id: "edit-system",
                align: "Right"
            }, {
                text: this.$t("Delete"),
                tooltipText: "Delete",
                prefixIcon: "e-delete",
                id: "delete-systems",
                align: "Right"
            }, "Search"],
            wrapSettingsSystems: { wrapMode: "Content" },
            selectionOptionsSystems: { type: "Single" },
            filterOptionsSystems: {
                type: "Menu"
            }
        };
    },

    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["f" /* ExcelExport */], __WEBPACK_IMPORTED_MODULE_2__syncfusion_ej2_vue_grids__["a" /* ColumnChooser */]]
    },
    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_7__api_api__["_15" /* getCloudServers */])();

                            case 2:
                                _this.servers = _context.sent;

                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        toolbarClick: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(args) {
                var selectedRow;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.t0 = args.item.id;
                                _context2.next = _context2.t0 === "clear-filters" ? 3 : _context2.t0 === "add-config" ? 5 : _context2.t0 === "delete-config" ? 7 : 12;
                                break;

                            case 3:
                                this.$refs.grid.clearFiltering();
                                return _context2.abrupt("break", 12);

                            case 5:
                                this.openModal("ADD");
                                return _context2.abrupt("break", 12);

                            case 7:
                                selectedRow = this.$refs.grid.getSelectedRecords();

                                if (selectedRow.length > 1) {
                                    alert("Select only one server to delete");
                                } else if (selectedRow.length == 0) {
                                    alert("Select server to delete.");
                                }
                                _context2.next = 11;
                                return Object(__WEBPACK_IMPORTED_MODULE_7__api_api__["A" /* deleteServer */])(selectedRow[0].id);

                            case 11:
                                this.getData();

                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function toolbarClick(_x) {
                return _ref.apply(this, arguments);
            }

            return toolbarClick;
        }(),
        dataBound: function dataBound() {
            this.$refs.grid.autoFitColumns();
        },
        toolbarClickSystems: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(args) {
                var selectedSystems;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.t0 = args.item.id;
                                _context3.next = _context3.t0 === "add-systems" ? 3 : _context3.t0 === "delete-system" ? 5 : _context3.t0 === "edit-system" ? 7 : 18;
                                break;

                            case 3:
                                this.openModal("ADD_SYSTEMS");
                                return _context3.abrupt("break", 18);

                            case 5:
                                this.openModal("DELETE_ASSIGMENT");
                                return _context3.abrupt("break", 18);

                            case 7:
                                selectedSystems = this.$refs.gridSystems.getSelectedRecords();

                                if (!(selectedSystems.length == 1)) {
                                    _context3.next = 12;
                                    break;
                                }

                                this.selectedSystem = selectedSystems[0];
                                _context3.next = 14;
                                break;

                            case 12:
                                alert("Select only one system");
                                return _context3.abrupt("break", 18);

                            case 14:

                                console.log(this.selectedSystem);
                                console.log(this.selectedServer);

                                this.openModal("EDIT_ASSIGNMENT");
                                return _context3.abrupt("break", 18);

                            case 18:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function toolbarClickSystems(_x2) {
                return _ref2.apply(this, arguments);
            }

            return toolbarClickSystems;
        }(),
        dataBoundSystems: function dataBoundSystems() {
            this.$refs.gridSystems.autoFitColumns();
        },
        closeModal: function closeModal(refresh) {
            if (refresh) {
                this.getData();
            }

            this.activeModal = "";
        },
        openModal: function openModal(name) {
            this.activeModal = name;
        },
        selectionChanged: function selectionChanged() {
            var _this2 = this;

            var selection = this.$refs.grid.getSelectedRecords();

            if (selection.length != 1) {
                this.selectedServer = null;
                this.systems = [];
                return;
            }

            this.selectedServer = selection[0];

            Object(__WEBPACK_IMPORTED_MODULE_7__api_api__["_47" /* getServerSystems */])(selection[0].id).then(function (result) {
                _this2.systems = result.sort(_this2.sortSystemsByName);
            });
        },
        sortSystemsByName: function sortSystemsByName(a, b) {
            return a.name.localeCompare(b.name, undefined, {
                numeric: true,
                sensitivity: "base"
            });
        }
    },
    mounted: function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            _context4.next = 2;
                            return this.getData();

                        case 2:
                        case "end":
                            return _context4.stop();
                    }
                }
            }, _callee4, this);
        }));

        function mounted() {
            return _ref3.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1903:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button_vue__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Select_vue__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(952);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        existing: {
            typeof: Object,
            required: false
        }
    },
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_2__Button_vue__["a" /* default */],
        Select: __WEBPACK_IMPORTED_MODULE_3__Select_vue__["a" /* default */]
    },
    data: function data() {
        return {
            users: [],
            config: {
                name: '',
                address: ''
            },
            error: ''
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__api__["_48" /* getServerUsers */])();

                            case 2:
                                _this.users = _context.sent;

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        save: function save() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                console.log('save clicked');

                            case 1:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            this.getData();

                        case 1:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1904:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button_vue__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__ = __webpack_require__(953);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        server: {
            typeof: Object,
            required: true
        }
    },
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["e" /* Edit */]]
    },
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_2__Button_vue__["a" /* default */]
    },
    data: function data() {
        return {
            systems: [],
            selectedSystems: [],
            error: "",
            numericParams: { params: { decimals: 0, value: 0 } },
            toolbar: ["Edit", "Update", "Cancel"]
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var result;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["_80" /* getSystemsAvailableForCloud */])();

                            case 2:
                                result = _context.sent;

                                _this.systems = result.sort(_this.sortSystemsByName);

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        sortSystemsByName: function sortSystemsByName(a, b) {
            return a.name.localeCompare(b.name, undefined, {
                numeric: true,
                sensitivity: "base"
            });
        },
        selectionChanged: function selectionChanged() {
            var selection = this.$refs.modal_grid.getSelectedRecords();
            this.selectedSystems = selection;
        },

        dataBound: function dataBound() {
            this.$refs.modal_grid.autoFitColumns();
        },
        dataBoundSelected: function dataBoundSelected() {
            this.$refs.selectedGrid.autoFitColumns();
        },
        save: function save() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var toSend;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                toSend = {
                                    serverId: _this2.server.id,
                                    systemInfo: []
                                };


                                _this2.selectedSystems.forEach(function (el) {
                                    toSend.systemInfo.push({
                                        systemId: el.id,
                                        herdIdentifier: el.herdIdentifier,
                                        producerNumber: el.producerNumber,
                                        clientId: el.clientId
                                    });
                                });

                                _context2.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_3__api_api__["m" /* assignServerSystem */])(toSend);

                            case 4:

                                _this2.$emit("save");

                            case 5:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return this.getData();

                        case 2:
                        case "end":
                            return _context3.stop();
                    }
                }
            }, _callee3, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1905:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button_vue__ = __webpack_require__(1543);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        selectedSystem: {
            type: Object
        },
        server: {
            type: Object,
            required: true
        }
    },
    components: {
        Button: __WEBPACK_IMPORTED_MODULE_3__Button_vue__["a" /* default */]
    },
    watch: {
        selectedSystem: {
            handler: function handler(newVal, oldVal) {
                console.log(newVal, oldVal);
                if (newVal == null) {
                    this.localSystem = {
                        herdIdentifier: null,
                        producerNumber: null,
                        clientId: null,
                        systemId: null
                    };
                } else {
                    this.localSystem = {
                        herdIdentifier: newVal.herdIdentifier,
                        producerNumber: newVal.producerNumber,
                        clientId: newVal.clientId,
                        systemId: newVal.id
                    };
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        save: function save() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.error = "";

                                if (!(_this.localSystem.herdIdentifier == "")) {
                                    _context.next = 4;
                                    break;
                                }

                                _this.error = "Herd Identifier required";
                                return _context.abrupt("return");

                            case 4:
                                if (!(_this.localSystem.producerNumber == "")) {
                                    _context.next = 7;
                                    break;
                                }

                                _this.error = "Producer Number required";
                                return _context.abrupt("return");

                            case 7:

                                console.log(_this.localSystem);

                                _context.prev = 8;
                                _context.next = 11;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api_api__["_116" /* updateCloudSystemAssigment */])(_this.server.id, _this.localSystem);

                            case 11:

                                _this.$emit("save", true);
                                _context.next = 17;
                                break;

                            case 14:
                                _context.prev = 14;
                                _context.t0 = _context["catch"](8);

                                alert(_context.t0);

                            case 17:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this, [[8, 14]]);
            }))();
        }
    },
    data: function data() {
        return {
            localSystem: {
                herdIdentifier: null,
                producerNumber: null,
                clientId: null
            },
            error: ""
        };
    },
    mounted: function mounted() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            console.log(_this2.selectedSystem);
                            console.log(_this2.localSystem);

                        case 2:
                        case "end":
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    }
});

/***/ }),

/***/ 2319:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2320);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("1ad7f1f1", content, true, {});

/***/ }),

/***/ 2320:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".messages-area{background:#f3f3f3;border:1px solid #e0e0e0;border-radius:5px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/BackupCloud.vue"],"names":[],"mappings":"AACA,eACI,mBAAmC,AACnC,yBAAyC,AACzC,iBAAmB,CACtB","file":"BackupCloud.vue","sourcesContent":["\n.messages-area {\n    background: rgba(243, 243, 243, 1);\n    border: 1px solid rgba(224, 224, 224, 1);\n    border-radius: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddCloudModal_vue__ = __webpack_require__(1903);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13419fd4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCloudModal_vue__ = __webpack_require__(2324);
function injectStyle (ssrContext) {
  __webpack_require__(2322)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13419fd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddCloudModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13419fd4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCloudModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2322:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2323);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("1c4687fb", content, true, {});

/***/ }),

/***/ 2323:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".error[data-v-13419fd4]{text-align:left!important;color:#fd8282;font-size:11px;font-weight:700;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important}#info-container[data-v-13419fd4]{width:50%;padding:20px;background:#fff;border:1px solid #efefef;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0 0 20px rgba(0,0,0,.1);box-shadow:0 0 20px rgba(0,0,0,.1);border-radius:5px 0 0 5px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}#systems-container[data-v-13419fd4]{width:50%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.gallery-container[data-v-13419fd4]{background:#f9f9f9;-webkit-box-shadow:0 0 40px rgba(53,110,138,.25);box-shadow:0 0 40px rgba(53,110,138,.25);border-radius:5px}.info-field[data-v-13419fd4]{border-bottom:1px solid #e9e9e9;margin-bottom:12px;margin-top:12px}.info-field-title[data-v-13419fd4]{font-style:normal;font-weight:600;font-size:12px;line-height:16px;color:#272727;margin:0}.info-field-row[data-v-13419fd4]{width:100%;margin:0;padding-bottom:5px}.info-field-value[data-v-13419fd4]{font-style:normal;font-weight:400;font-size:12px;line-height:16px;color:#272727}.section-title[data-v-13419fd4]{font-weight:700}input[type=email][data-v-13419fd4],input[type=password][data-v-13419fd4],input[type=text][data-v-13419fd4]{border:unset;border-bottom:1px solid #0095b233;width:100%}input[type=email][data-v-13419fd4]:focus,input[type=password][data-v-13419fd4]:focus,input[type=text][data-v-13419fd4]:focus{border-bottom:1px solid #0095b2;outline:none}select[data-v-13419fd4]{border:none;width:100%}select[data-v-13419fd4]:focus{outline:none;border-bottom:1px solid #0095b2}option[data-v-13419fd4]{padding:4px}option[data-v-13419fd4]:checked{background:#347c93;color:#fff}.alarm-type-card[data-v-13419fd4]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f3f3f3;cursor:pointer;padding:0 12px;border:1px solid #e0e0e0;border-radius:5px;height:30px;margin:5px;-webkit-box-shadow:0 4px 5px 0 rgba(0,0,0,.1);box-shadow:0 4px 5px 0 rgba(0,0,0,.1);-ms-flex-item-align:center;text-align:left;background-color:#fff}.alarm-type-card[data-v-13419fd4]:hover{background-color:rgba(0,125,149,.1);color:#000}.selected-alarm-type[data-v-13419fd4]{background-color:#007d95;color:#fff}.disablegrid[data-v-13419fd4]{pointer-events:none;opacity:.4}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Cloud/AddCloudModal.vue"],"names":[],"mappings":"AACA,wBACI,0BAA4B,AAC5B,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,2CAAgD,AAChD,4BAA8B,AAC9B,yBAA4B,CAC/B,AACD,iCACI,UAAW,AACX,aAAc,AAEd,gBAAoB,AACpB,yBAA0B,AAC1B,8BAA+B,AACvB,sBAAuB,AAC/B,2CAAoD,AAC5C,mCAA4C,AACpD,0BAA+B,AAE/B,yBAA0B,AAEtB,sBAAuB,AAEnB,8BAA+B,AACvC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAClC,AACD,oCACI,UAAW,AACX,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CAEnC,AACD,oCACI,mBAAoB,AACpB,iDAA0D,AAClD,yCAAkD,AAC1D,iBAAmB,CACtB,AACD,6BACI,gCAAiC,AACjC,mBAAoB,AACpB,eAAiB,CACpB,AACD,mCACI,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAElB,cAAe,AACf,QAAU,CACb,AACD,iCACI,WAAY,AACZ,SAAU,AACV,kBAAoB,CACvB,AACD,mCACI,kBAAmB,AACnB,gBAAoB,AACpB,eAAgB,AAChB,iBAAkB,AAElB,aAAe,CAClB,AACD,gCACI,eAAkB,CACrB,AACD,2GACI,aAAc,AACd,kCAAmC,AACnC,UAAY,CACf,AACD,6HACI,gCAAiC,AACjC,YAAc,CACjB,AACD,wBACI,YAAa,AACb,UAAY,CACf,AACD,8BACI,aAAc,AACd,+BAAiC,CACpC,AACD,wBACI,WAAa,CAChB,AACD,gCACI,mBAAoB,AACpB,UAAa,CAChB,AACD,kCACC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAAyC,AACzC,eAAgB,AAChB,eAAgB,AAChB,yBAAyC,AACzC,kBAAmB,AACnB,YAAa,AACb,WAAgB,AAChB,8CAAmD,AAC3C,sCAA2C,AACnD,2BAA4B,AAC5B,gBAAiB,AACjB,qBAAwB,CACxB,AACD,wCACC,oCAAyC,AACzC,UAAa,CACb,AACD,sCACC,yBAAuC,AACvC,UAAa,CACb,AACD,8BACI,oBAAqB,AACrB,UAAa,CAChB","file":"AddCloudModal.vue","sourcesContent":["\n.error[data-v-13419fd4] {\n    text-align: left !important;\n    color: #FD8282;\n    font-size: 11px;\n    font-weight: bold;\n    font-family: 'Open Sans', sans-serif !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n}\n#info-container[data-v-13419fd4] {\n    width: 50%;\n    padding: 20px;\n\n    background: #FFFFFF;\n    border: 1px solid #EFEFEF;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    border-radius: 5px 0px 0px 5px;\n\n    -webkit-box-pack: justify;\n\n        -ms-flex-pack: justify;\n\n            justify-content: space-between;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n#systems-container[data-v-13419fd4] {\n    width: 50%;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    /* margin: auto; */\n}\n.gallery-container[data-v-13419fd4] {\n    background: #F9F9F9;\n    -webkit-box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n            box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n    border-radius: 5px;\n}\n.info-field[data-v-13419fd4] {\n    border-bottom: 1px solid #E9E9E9;\n    margin-bottom: 12px;\n    margin-top: 12px;\n}\n.info-field-title[data-v-13419fd4] {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n    margin: 0;\n}\n.info-field-row[data-v-13419fd4] {\n    width: 100%;\n    margin: 0;\n    padding-bottom: 5px;\n}\n.info-field-value[data-v-13419fd4] {\n    font-style: normal;\n    font-weight: normal;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n}\n.section-title[data-v-13419fd4] {\n    font-weight: bold;\n}\ninput[type=text][data-v-13419fd4], input[type=\"email\"][data-v-13419fd4], input[type=\"password\"][data-v-13419fd4] {\n    border: unset;\n    border-bottom: 1px solid #0095b233;\n    width: 100%;\n}\ninput[type=text][data-v-13419fd4]:focus, input[type=\"email\"][data-v-13419fd4]:focus, input[type=\"password\"][data-v-13419fd4]:focus {\n    border-bottom: 1px solid #0095b2;\n    outline: none;\n}\nselect[data-v-13419fd4] {\n    border: none;\n    width: 100%;\n}\nselect[data-v-13419fd4]:focus {\n    outline: none;\n    border-bottom: 1px solid #0095b2;\n}\noption[data-v-13419fd4] {\n    padding: 4px;\n}\noption[data-v-13419fd4]:checked {\n    background: #347C93;\n    color: white;\n}\n.alarm-type-card[data-v-13419fd4] {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\tbackground-color: rgba(243, 243, 243, 1);\n\tcursor: pointer;\n\tpadding: 0 12px;\n\tborder: 1px solid rgba(224, 224, 224, 1);\n\tborder-radius: 5px;\n\theight: 30px;\n\tmargin: 5px 5px;\n\t-webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1);\n\t        box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.1);\n\t-ms-flex-item-align: center;\n\ttext-align: left;\n\tbackground-color: white;\n}\n.alarm-type-card[data-v-13419fd4]:hover {\n\tbackground-color: rgba(0, 125, 149, 0.1);\n\tcolor: black;\n}\n.selected-alarm-type[data-v-13419fd4] {\n\tbackground-color: rgba(0, 125, 149, 1);\n\tcolor: white;\n}\n.disablegrid[data-v-13419fd4] {\n    pointer-events: none;\n    opacity: 0.4;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal grow gallery-container",staticStyle:{"min-width":"700px","width":"50vw","height":"70vh"}},[_c('div',{attrs:{"id":"info-container"}},[_c('div',[_c('p',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t('NEW_SERVER_CONFIG')))]),_vm._v(" "),_c('div',[_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Name')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.config.name),expression:"config.name"}],attrs:{"type":"text","placeholder":_vm.$t('Name')},domProps:{"value":(_vm.config.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.config, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Address')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.config.address),expression:"config.address"}],attrs:{"type":"text","placeholder":_vm.$t('Address')},domProps:{"value":(_vm.config.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.config, "address", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t('Profile')))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"200px"}},[_c('select',{attrs:{"id":"usersid"}},_vm._l((_vm.users),function(user){return _c('option',{key:user.id},[_vm._v("\n                                    "+_vm._s(user.publicName)+" "),(user.currentServer != '')?_c('span',[_vm._v("("+_vm._s(user.currentServer)+")")]):_vm._e()])}),0)])])]),_vm._v(" "),_c('div',[(_vm.error != '')?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticStyle:{"align-self":"center"}},[_c('Button',{staticStyle:{"width":"300px","align-self":"center"},attrs:{"title":_vm.$t('Save'),"buttonClass":"save-button semi-bold"},on:{"onClick":_vm.save}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddCloudSystemModal_vue__ = __webpack_require__(1904);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eb83eba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCloudSystemModal_vue__ = __webpack_require__(2328);
function injectStyle (ssrContext) {
  __webpack_require__(2326)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3eb83eba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddCloudSystemModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eb83eba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddCloudSystemModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2326:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2327);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("4ba2ee04", content, true, {});

/***/ }),

/***/ 2327:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".error[data-v-3eb83eba]{text-align:left!important;color:#fd8282;font-size:11px;font-weight:700;font-family:Open Sans,sans-serif!important;font-style:normal!important;font-weight:400!important}#info-container[data-v-3eb83eba]{padding:20px;background:#fff;border:1px solid #efefef;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0 0 20px rgba(0,0,0,.1);box-shadow:0 0 20px rgba(0,0,0,.1);border-radius:5px 0 0 5px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.section-title[data-v-3eb83eba]{font-weight:700}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Cloud/AddCloudSystemModal.vue"],"names":[],"mappings":"AACA,wBACI,0BAA4B,AAC5B,cAAe,AACf,eAAgB,AAChB,gBAAkB,AAClB,2CAAgD,AAChD,4BAA8B,AAC9B,yBAA4B,CAC/B,AACD,iCAEI,aAAc,AAEd,gBAAoB,AACpB,yBAA0B,AAC1B,8BAA+B,AACvB,sBAAuB,AAC/B,2CAAoD,AAC5C,mCAA4C,AACpD,0BAA+B,AAE/B,yBAA0B,AAEtB,sBAAuB,AAEnB,8BAA+B,AACvC,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAClC,AACD,gCACI,eAAkB,CACrB","file":"AddCloudSystemModal.vue","sourcesContent":["\n.error[data-v-3eb83eba] {\n    text-align: left !important;\n    color: #fd8282;\n    font-size: 11px;\n    font-weight: bold;\n    font-family: \"Open Sans\", sans-serif !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n}\n#info-container[data-v-3eb83eba] {\n    /* width: 50%; */\n    padding: 20px;\n\n    background: #ffffff;\n    border: 1px solid #efefef;\n    -webkit-box-sizing: border-box;\n            box-sizing: border-box;\n    -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n    border-radius: 5px 0px 0px 5px;\n\n    -webkit-box-pack: justify;\n\n        -ms-flex-pack: justify;\n\n            justify-content: space-between;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n}\n.section-title[data-v-3eb83eba] {\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal grow gallery-container",staticStyle:{"min-width":"800px","width":"70vw","height":"70vh"}},[_c('div',{attrs:{"id":"info-container"}},[_c('div',[_c('p',{staticClass:"section-title"},[_vm._v("\n                "+_vm._s(_vm.$t("ADD_SYSTEMS_TO_SERVER"))+": "+_vm._s(_vm.server.name)+"\n            ")]),_vm._v(" "),_c('div',{staticStyle:{"max-height":"60vh","overflow":"auto"}},[_c('ejs-grid',{ref:"selectedGrid",attrs:{"height":"100%","width":"100%","dataSource":_vm.selectedSystems,"selectionSettings":{ type: 'Single' },"dataBound":_vm.dataBoundSelected,"allowSorting":true,"editSettings":{
                        allowEditing: true,
                        allowAdding: true,
                        mode: 'Normal',
                    },"toolbar":_vm.toolbar}},[_c('e-columns',[_c('e-column',{attrs:{"field":"name","headerText":_vm.$t('Name'),"textAlign":"Left","isPrimaryKey":true}}),_vm._v(" "),_c('e-column',{attrs:{"field":"herdIdentifier","headerText":_vm.$t('HerdIdentifier'),"textAlign":"Left","edit":_vm.numericParams}}),_vm._v(" "),_c('e-column',{attrs:{"field":"producerNumber","headerText":_vm.$t('ProducerNumber'),"textAlign":"Left","edit":_vm.numericParams}}),_vm._v(" "),_c('e-column',{attrs:{"field":"clientId","headerText":_vm.$t('ClientId'),"textAlign":"Left"}})],1)],1),_vm._v(" "),_c('div',[(_vm.error != '')?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticStyle:{"align-self":"center"}},[_c('Button',{staticStyle:{"width":"300px","align-self":"center"},attrs:{"title":_vm.$t('Save'),"buttonClass":"save-button semi-bold"},on:{"onClick":_vm.save}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"display":"block"},attrs:{"id":"systems-container"}},[_c('h4',{staticStyle:{"padding-top":"10px"}},[_vm._v(_vm._s(_vm.$t("Systems")))]),_vm._v(" "),_c('div',{staticStyle:{"height":"90%","width":"90%","margin":"auto","padding":"0 0 10px 0"}},[_c('ejs-grid',{ref:"modal_grid",attrs:{"height":"100%","width":"100%","selectionSettings":{ type: 'Multiple' },"allowTextWrap":true,"textWrapSettings":{ wrapMode: 'Content' },"dataBound":_vm.dataBound,"dataSource":_vm.systems,"showBusyIndicator":true,"rowSelected":_vm.selectionChanged,"rowDeselected":_vm.selectionChanged}},[_c('e-columns',[_c('e-column',{attrs:{"type":"checkbox","width":"50","headerText":"Discontinued"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"name","headerText":_vm.$t('Name'),"textAlign":"Left"}})],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCloudSystem_vue__ = __webpack_require__(1905);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6300ffee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCloudSystem_vue__ = __webpack_require__(2332);
function injectStyle (ssrContext) {
  __webpack_require__(2330)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6300ffee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCloudSystem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6300ffee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditCloudSystem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2330:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2331);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("4a59facc", content, true, {});

/***/ }),

/***/ 2331:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".gallery-container[data-v-6300ffee]{background:#f9f9f9;-webkit-box-shadow:0 0 40px rgba(53,110,138,.25);box-shadow:0 0 40px rgba(53,110,138,.25);border-radius:5px}.section-title[data-v-6300ffee]{text-align:center}.info-field[data-v-6300ffee]{border-bottom:1px solid #e9e9e9;margin-bottom:12px;margin-top:12px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.info-field-title[data-v-6300ffee]{font-style:normal;font-weight:600;font-size:12px;line-height:16px;color:#272727;margin:0}.info-field-row[data-v-6300ffee]{-ms-flex-item-align:center;align-self:center;width:80%;margin:0;padding-bottom:5px}.section-title[data-v-6300ffee]{font-weight:700}input.datalist-input[data-v-6300ffee],input.version-input[data-v-6300ffee],select[data-v-6300ffee]{width:210px;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgb(0 0 0/8%);box-shadow:inset 0 1px 1px rgb(0 0 0/8%)}.version-input[data-v-6300ffee]{height:25px;margin:0 10px;width:100px!important}textarea[data-v-6300ffee]{height:200px;max-height:300px;width:210px;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgb(0 0 0/8%);box-shadow:inset 0 1px 1px rgb(0 0 0/8%)}.info-field-row>td[data-v-6300ffee]{vertical-align:middle}.error[data-v-6300ffee]{font-size:14px}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Cloud/EditCloudSystem.vue"],"names":[],"mappings":"AACA,oCACI,mBAAoB,AACpB,iDAA0D,AAClD,yCAAkD,AAC1D,iBAAmB,CACtB,AACD,gCAEI,iBAAmB,CACtB,AACD,6BACI,gCAAiC,AACjC,mBAAoB,AACpB,gBAAiB,AACjB,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,mCACI,kBAAmB,AACnB,gBAAiB,AACjB,eAAgB,AAChB,iBAAkB,AAElB,cAAe,AACf,QAAU,CACb,AACD,iCACI,2BAA4B,AACxB,kBAAmB,AACvB,UAAW,AACX,SAAU,AACV,kBAAoB,CACvB,AACD,gCACI,eAAkB,CACrB,AACD,mGAGI,YAAa,AACb,sBAAuB,AACvB,kBAAmB,AACnB,iDAAoD,AACpD,wCAA4C,CAC/C,AACD,gCACI,YAAa,AACb,cAAe,AACf,qBAAwB,CAC3B,AACD,0BACI,aAAc,AACd,iBAAkB,AAClB,YAAa,AACb,sBAAuB,AACvB,kBAAmB,AACnB,iDAAoD,AACpD,wCAA4C,CAC/C,AACD,oCACI,qBAAuB,CAC1B,AACD,wBACI,cAAgB,CACnB","file":"EditCloudSystem.vue","sourcesContent":["\n.gallery-container[data-v-6300ffee] {\n    background: #f9f9f9;\n    -webkit-box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n            box-shadow: 0px 0px 40px rgba(53, 110, 138, 0.25);\n    border-radius: 5px;\n}\n.section-title[data-v-6300ffee] {\n    font-weight: bold;\n    text-align: center;\n}\n.info-field[data-v-6300ffee] {\n    border-bottom: 1px solid #e9e9e9;\n    margin-bottom: 12px;\n    margin-top: 12px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.info-field-title[data-v-6300ffee] {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 16px;\n\n    color: #272727;\n    margin: 0;\n}\n.info-field-row[data-v-6300ffee] {\n    -ms-flex-item-align: center;\n        align-self: center;\n    width: 80%;\n    margin: 0;\n    padding-bottom: 5px;\n}\n.section-title[data-v-6300ffee] {\n    font-weight: bold;\n}\nselect[data-v-6300ffee],\ninput.datalist-input[data-v-6300ffee],\ninput.version-input[data-v-6300ffee] {\n    width: 210px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n}\n.version-input[data-v-6300ffee] {\n    height: 25px;\n    margin: 0 10px;\n    width: 100px !important;\n}\ntextarea[data-v-6300ffee] {\n    height: 200px;\n    max-height: 300px;\n    width: 210px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n    box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);\n}\n.info-field-row > td[data-v-6300ffee] {\n    vertical-align: middle;\n}\n.error[data-v-6300ffee] {\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical grow gallery-container",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t("HerdIdentifier")))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"400px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localSystem.herdIdentifier),expression:"localSystem.herdIdentifier"}],staticClass:"datalist-input",staticStyle:{"width":"100%"},attrs:{"id":"product-select-input"},domProps:{"value":(_vm.localSystem.herdIdentifier)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localSystem, "herdIdentifier", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t("ProducerNumber")))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"400px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localSystem.producerNumber),expression:"localSystem.producerNumber"}],staticClass:"datalist-input",staticStyle:{"width":"100%"},attrs:{"id":"product-select-input"},domProps:{"value":(_vm.localSystem.producerNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localSystem, "producerNumber", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"info-field horizontal"},[_c('tr',{staticClass:"info-field-row"},[_c('td',{staticClass:"title-td",staticStyle:{"width":"200px"}},[_c('p',{staticClass:"info-field-title"},[_vm._v(_vm._s(_vm.$t("ClientId")))])]),_vm._v(" "),_c('td',{staticClass:"info-field-value",staticStyle:{"width":"400px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localSystem.clientId),expression:"localSystem.clientId"}],staticClass:"datalist-input",staticStyle:{"width":"100%"},attrs:{"id":"product-select-input"},domProps:{"value":(_vm.localSystem.clientId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localSystem, "clientId", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticStyle:{"align-self":"center","margin-bottom":"20px"}},[_c('div',{staticClass:"horizontal",staticStyle:{"justify-content":"center","margin-bottom":"10px"}},[(_vm.error != '')?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()]),_vm._v(" "),_c('Button',{staticStyle:{"width":"300px","align-self":"center"},attrs:{"title":_vm.$t('Save'),"buttonClass":"save-button semi-bold"},on:{"onClick":_vm.save}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('modal',{attrs:{"showDialog":_vm.activeModal === 'ADD' ||
            (_vm.activeModal == 'EDIT' && _vm.selectedServer != null),"title":_vm.$t('AddServer')},on:{"close":_vm.closeModal}},[_c('add-cloud-modal',{attrs:{"existing":_vm.selectedServer}})],1),_vm._v(" "),_c('modal',{attrs:{"showDialog":_vm.activeModal === 'ADD_SYSTEMS',"title":_vm.$t('AddSystems')},on:{"close":_vm.closeModal}},[_c('add-cloud-system-modal',{attrs:{"server":_vm.selectedServer},on:{"save":function($event){return _vm.closeModal(true)}}})],1),_vm._v(" "),_c('modal',{attrs:{"showDialog":_vm.activeModal === 'EDIT_ASSIGNMENT',"title":_vm.$t('EditSystem')},on:{"close":_vm.closeModal}},[_c('edit-cloud-system',{attrs:{"selectedSystem":_vm.selectedSystem,"server":_vm.selectedServer},on:{"save":function($event){return _vm.closeModal(true)}}})],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"max-grid",staticStyle:{"flex-direction":"row"}},[_c('ejs-grid',{ref:"grid",staticStyle:{"position":"relative"},attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"toolbarClick":_vm.toolbarClick,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.servers,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"showBusyIndicator":true,"enablePersistence":false,"rowSelected":_vm.selectionChanged,"rowDeselected":_vm.selectionChanged}},[_c('e-columns',[_c('e-column',{attrs:{"field":"name","headerText":_vm.$t('Name'),"textAlign":"Left"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"address","headerText":_vm.$t('Address'),"textAlign":"Left"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"systemsCount","headerText":_vm.$t('Systems'),"textAlign":"Left"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"managerName","headerText":_vm.$t('Profile'),"textAlign":"Left"}})],1)],1),_vm._v(" "),(_vm.selectedServer != null)?_c('div',{staticClass:"messages-area",staticStyle:{"min-width":"35%","width":"35%","margin":"0 0 0 10px"}},[_c('h4',{staticStyle:{"width":"100%","text-align":"center","padding":"10px 0"}},[_vm._v("\n                    "+_vm._s(_vm.$t("AssignedSystems"))+"\n                ")]),_vm._v(" "),_c('ejs-grid',{ref:"gridSystems",staticStyle:{"height":"calc(100% - 20px)","position":"relative"},attrs:{"width":"100%","toolbar":_vm.toolbarSystems,"toolbarClick":_vm.toolbarClickSystems,"selectionSettings":_vm.selectionOptionsSystems,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettingsSystems,"dataBound":_vm.dataBoundSystems,"dataSource":_vm.systems,"allowFiltering":true,"filterSettings":_vm.filterOptionsSystems,"allowSorting":true,"showBusyIndicator":true,"enablePersistence":false}},[_c('e-columns',[_c('e-column',{attrs:{"field":"name","headerText":_vm.$t('Name'),"textAlign":"Left"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"herdIdentifier","headerText":_vm.$t('HerdIdentifier'),"textAlign":"Left"}}),_vm._v(" "),_c('e-column',{attrs:{"field":"producerNumber","headerText":_vm.$t('ProducerNumber'),"textAlign":"Left"}})],1)],1)],1):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/22.f30a88dea1bc8819d443.js